import React from "react";
import PropTypes from "prop-types";

const LinkPreviewIcon = ({ size = 36, className = "" }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 36 36"
        fill="none"
        aria-hidden="true"
        className={className}
    >
        <defs>
            <linearGradient id="linkPreviewGradient" x1="6" y1="30" x2="30" y2="6" gradientUnits="userSpaceOnUse">
                <stop stopColor="#8E8CFF" />
                <stop offset="1" stopColor="#58E0FF" />
            </linearGradient>
        </defs>
        <circle cx="18" cy="18" r="16" fill="rgba(122, 146, 255, 0.18)" />
        <path
            d="M14.5 18C14.5 16.07 16.07 14.5 18 14.5H21C22.93 14.5 24.5 16.07 24.5 18C24.5 19.93 22.93 21.5 21 21.5H20"
            stroke="url(#linkPreviewGradient)"
            strokeWidth="1.6"
            strokeLinecap="round"
        />
        <path
            d="M21.5 18C21.5 19.93 19.93 21.5 18 21.5H15C13.07 21.5 11.5 19.93 11.5 18C11.5 16.07 13.07 14.5 15 14.5H16"
            stroke="url(#linkPreviewGradient)"
            strokeWidth="1.6"
            strokeLinecap="round"
        />
    </svg>
);

LinkPreviewIcon.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
};

export default LinkPreviewIcon;
